/**
 * svg_animations.js.
 *
 */

(function($) {

	// Explore arrow
	var exp_svg = document.getElementById('explore-arrow');

	if ( exp_svg !== null ) {
		var exp_s = Snap(exp_svg);
		var exp_shortArrow = Snap.select('#explore-arrow .short-arrow');
		var exp_longArrow = Snap.select('#explore-arrow .long-arrow');
		var exp_shortArrowPoints = exp_shortArrow.node.getAttribute('d');
		var exp_longArrowPoints = exp_longArrow.node.getAttribute('d');
		var exp_toLongArrow = function(){
		  exp_shortArrow.animate({ d: exp_longArrowPoints }, 300, mina.linear);  
		}
		var exp_toShortArrow = function(){
		  exp_shortArrow.animate({ d: exp_shortArrowPoints }, 300, mina.linear); 
		}

		$('.hero-block--cta a.has-arrow').mouseover(function() {
		  exp_toLongArrow();
		}).focus(function() {
		  exp_toLongArrow();
		});

		$('.hero-block--cta a.has-arrow').mouseout(function() {
		  exp_toShortArrow();
		}).focusout(function() {
		  exp_toShortArrow();
		});
	}


	// Back to top arrow
	var btt_svg = document.getElementById('back-to-top-arrow');

	if ( btt_svg !== null ) {
	  var btt_s = Snap(btt_svg);
		var btt_shortArrow = Snap.select('#back-to-top-arrow .short-arrow');
		var btt_longArrow = Snap.select('#back-to-top-arrow .long-arrow');
		var btt_shortArrowPoints = btt_shortArrow.node.getAttribute('d');
		var btt_longArrowPoints = btt_longArrow.node.getAttribute('d');
		var btt_toLongArrow = function(){
		  btt_shortArrow.animate({ d: btt_longArrowPoints }, 400, mina.linear);  
		}
		var btt_toShortArrow = function(){
		  btt_shortArrow.animate({ d: btt_shortArrowPoints }, 400, mina.linear); 
		}

		$('a.has-arrow.back-to-top').mouseover(function() {
		  btt_toLongArrow();
		}).focus(function() {
		  btt_toLongArrow();
		});

		$('a.has-arrow.back-to-top').mouseout(function() {
		  btt_toShortArrow();
		}).focusout(function() {
		  btt_toShortArrow();
		});
	}

})(jQuery);
